import { Skeleton } from '@mui/material'
import React, { Fragment } from 'react'


const BarChartLoader = ({ size }: { size?: number }) => {
    return (
        <>
            {[...(new Array(size || 6))].map((_, index) => {
                return (
                    <Fragment key={index}>
                        <Skeleton variant="rectangular" width={20} sx={{ minWidth: "20px !important" }} height={`${getRandomNumber()}%`} />
                        <Skeleton variant="rectangular" width={20} sx={{ minWidth: "20px !important" }} height={`${getRandomNumber()}%`} />
                        <Skeleton variant="rectangular" width={20} sx={{ minWidth: "20px !important", mr: 3 }} height={`${getRandomNumber()}%`} />
                    </Fragment>
                )
            })}
        </>
    )
}

export default BarChartLoader;
const getRandomNumber = () => {
    return Math.floor(Math.random() * (80 - 20 + 1)) + 20;
}